/**
 * ----- Export des données associées à chaque route -----
 */
import React from 'react';
import {CiImport} from "react-icons/ci";

import { FaChevronRight } from "react-icons/fa";
import {
  BsTable,
  BsTools,
  BsPeople,
  BsPlusCircle,
  BsPencilSquare,
  BsPersonPlus,
  BsLayoutTextSidebarReverse,
  BsPieChart,
  BsBriefcase,
  BsAirplane,
  BsFileText,
  BsListUl,
  BsBell,
} from "react-icons/bs";

// Removed React.memo for react-icons compatibility



/** Caractéristiques d'une route */
export interface I_ROUTE_DATA {
  /** Route enregistree dans le router */
  route: string;
  /** Fonction generant l'icone associee. Prend la taille, la marge gauche et droite en paramètres. */
  icon: (size:number,ml?:number,mr?:number) => any;
  /** Libellé associé */
  title?: string;
  /** Clé i18n du libellé associé */
  titleKey?: string;
  /** true si la route n'est pas accessible en l'absence d'access_token dans le GlobalContext */
  requireLogin: boolean;
  /** Liste des clé de rôles requis pour accéder à la route.
   * Si vide, pas de contrainte d'accès.
   * Si plusieurs clés, le role en GlobalContext doit valider au moins l'un d'eux. */
  requireRole?: string[];
  /** Liste des clé de rôles-functions requis pour accéder à la route.
   * Si vide, pas de contrainte d'accès.
   * Si plusieurs clés, le role en GlobalContext doit valider au moins l'un d'eux.
   * La paire role/function à valider s'écrit de la forme 'role-function'
   * Cet attribut requis prévaut sur l'attribut "requireRole". Si il est présent, l'attribut "requireRole" est ignoré.
   * Si "role" ou "role-" ou "role-*", seul le role est requis */
  requireRoleFunction?: string[];
  /**
   * Si présent, au moins un des endpoints listés doit être validé dans le GlobalContext pour accéder à la route
   * Si plusieurs clés, le user doit valider au moins l'un d'eux pour accéder à la route
   * Si vide ou non présent, pas de contrainte d'accès basée sur les endpoints
   */
  requireOneOfEndpoints?: string[];
  /** Clé indiquant l'ajout d'un suffix. ex : 'alertsBadge' */
  suffixKey?: string;
}
export interface I_ROUTES_DATAS {
  [key:string]: I_ROUTE_DATA;
}
const ROUTES:I_ROUTES_DATAS = {
  '/styleguide': {
    route: 'styleguide',
    icon: (size:number,ml?:number,mr?:number) => <FaChevronRight className={`h-${size} w-${size} ${ml ? 'ml-'+ml : ''} ${mr ? 'mr-'+mr : ''}`}/>,
    title: 'Styleguide',
    requireLogin: false,
    requireRoleFunction: [],
  },
  '/styleguide/alerts': {
    route: 'styleguide/alerts',
    icon: (size:number,ml?:number,mr?:number) => <FaChevronRight className={`h-${size} w-${size} ${ml ? 'ml-'+ml : ''} ${mr ? 'mr-'+mr : ''}`}/>,
    title: 'Alerts & Loading',
    requireLogin: false,
    requireRoleFunction: [],
  },
  '/styleguide/keycards': {
    route: 'styleguide/keycards',
    icon: (size:number,ml?:number,mr?:number) => <FaChevronRight className={`h-${size} w-${size} ${ml ? 'ml-'+ml : ''} ${mr ? 'mr-'+mr : ''}`}/>,
    title: 'KeyCards',
    requireLogin: false,
    requireRole: [],
  },
  '/styleguide/buttons': {
    route: 'styleguide/buttons',
    icon: (size:number,ml?:number,mr?:number) => <FaChevronRight className={`h-${size} w-${size} ${ml ? 'ml-'+ml : ''} ${mr ? 'mr-'+mr : ''}`}/>,
    title: 'Buttons & Toasts & Tooltips & Chips',
    requireLogin: false,
    requireRoleFunction: [],
  },
  '/styleguide/tables': {
    route: 'styleguide/tables',
    icon: (size:number,ml?:number,mr?:number) => <FaChevronRight className={`h-${size} w-${size} ${ml ? 'ml-'+ml : ''} ${mr ? 'mr-'+mr : ''}`}/>,
    title: 'Tables',
    requireLogin: false,
    requireRoleFunction: [],
  },
  '/styleguide/progress': {
    route: 'styleguide/progress',
    icon: (size:number,ml?:number,mr?:number) => <FaChevronRight className={`h-${size} w-${size} ${ml ? 'ml-'+ml : ''} ${mr ? 'mr-'+mr : ''}`}/>,
    title: 'Progress',
    requireLogin: false,
    requireRoleFunction: [],
  },
  '/styleguide/charts': {
    route: 'styleguide/charts',
    icon: (size:number,ml?:number,mr?:number) => <FaChevronRight className={`h-${size} w-${size} ${ml ? 'ml-'+ml : ''} ${mr ? 'mr-'+mr : ''}`}/>,
    title: 'Charts',
    requireLogin: false,
    requireRole: [],
  },
  '/styleguide/timelines': {
    route: 'styleguide/timelines',
    icon: (size:number,ml?:number,mr?:number) => <FaChevronRight className={`h-${size} w-${size} ${ml ? 'ml-'+ml : ''} ${mr ? 'mr-'+mr : ''}`}/>,
    title: 'Timelines',
    requireLogin: false,
    requireRoleFunction: [],
  },
  '/styleguide/cards': {
    route: 'styleguide/cards',
    icon: (size:number,ml?:number,mr?:number) => <FaChevronRight className={`h-${size} w-${size} ${ml ? 'ml-'+ml : ''} ${mr ? 'mr-'+mr : ''}`}/>,
    title: 'Cards & Modals',
    requireLogin: false,
    requireRoleFunction: [],
  },
  '/styleguide/avatars': {
    route: 'styleguide/avatars',
    icon: (size:number,ml?:number,mr?:number) => <FaChevronRight className={`h-${size} w-${size} ${ml ? 'ml-'+ml : ''} ${mr ? 'mr-'+mr : ''}`}/>,
    title: 'Avatars',
    requireLogin: false,
    requireRoleFunction: [],
  },
  '/styleguide/fields': {
    route: 'styleguide/fields',
    icon: (size:number,ml?:number,mr?:number) => <FaChevronRight className={`h-${size} w-${size} ${ml ? 'ml-'+ml : ''} ${mr ? 'mr-'+mr : ''}`}/>,
    title: 'Champs',
    requireLogin: false,
    requireRoleFunction: [],
  },
  '/login': {
    route: 'login',
    icon: (size:number,ml?:number,mr?:number) => <FaChevronRight className={`h-${size} w-${size} ${ml ? 'ml-'+ml : ''} ${mr ? 'mr-'+mr : ''}`}/>,
    title: 'Login',
    requireLogin: false,
    requireRoleFunction: [],
  },
  '/reset-password': {
    route: 'reset-password',
    icon: (size:number,ml?:number,mr?:number) => <FaChevronRight className={`h-${size} w-${size} ${ml ? 'ml-'+ml : ''} ${mr ? 'mr-'+mr : ''}`}/>,
    title: 'Reset Password',
    requireLogin: false,
    requireRoleFunction: [],
  },
  '/': {
    route: '',
    icon: (size:number,ml?:number,mr?:number) => <FaChevronRight className={`h-${size} w-${size} ${ml ? 'ml-'+ml : ''} ${mr ? 'mr-'+mr : ''}`}/>,
    title: 'Page de test Guest',
    requireLogin: true,
    requireRoleFunction: [],
  },
  // '/home': {
  //   route: 'home',
  //   icon: (size:number,ml?:number,mr?:number) => <MemoizedBsSpeedometer2 className={`h-${size} w-${size} ${ml ? 'ml-'+ml : ''} ${mr ? 'mr-'+mr : ''}`}/>,
  //   titleKey: 'routes.home.title',
  //   requireLogin: true,
  //   requireRoleFunction: [],
  // },
  '/plan-de-charge': {
    route: 'plan-de-charge',
    icon: (size:number,ml?:number,mr?:number) => <BsTable className={`h-${size} w-${size} ${ml ? 'ml-'+ml : ''} ${mr ? 'mr-'+mr : ''}`}/>,
    titleKey: 'routes.plan-de-charge.title',
    requireLogin: true,
    requireRoleFunction: [],
    requireOneOfEndpoints: ['GET /planification'],
  },
  '/referentiel-activites': {
    route: 'referentiel-activites',
    icon: (size:number,ml?:number,mr?:number) => <BsListUl className={`h-${size} w-${size} ${ml ? 'ml-'+ml : ''} ${mr ? 'mr-'+mr : ''}`}/>,
    titleKey: 'routes.referentiel-activites.title',
    requireLogin: true,
    requireRole: ['administrator','sa','manager'],
    requireOneOfEndpoints: ['GET /activity_types'],
  },
  '/referentiel-taches': {
    route: 'referentiel-taches',
    icon: (size:number,ml?:number,mr?:number) => <BsListUl className={`h-${size} w-${size} ${ml ? 'ml-'+ml : ''} ${mr ? 'mr-'+mr : ''}`}/>,
    titleKey: 'routes.referentiel-taches.title',
    requireLogin: true,
    requireRoleFunction: ['manager','sa'],
    requireOneOfEndpoints: ['GET /task_types'],
  },
  '/referentiel-competences': {
    route: 'referentiel-competences',
    icon: (size:number,ml?:number,mr?:number) => <BsTools className={`h-${size} w-${size} ${ml ? 'ml-'+ml : ''} ${mr ? 'mr-'+mr : ''}`}/>,
    titleKey: 'routes.referentiel-competences.title',
    requireLogin: true,
    requireRoleFunction: ['manager','hr','sa'],
    requireOneOfEndpoints: ['GET /skills'],
  },
  '/referentiel-donneurs-d-ordre': {
    route: 'referentiel-donneurs-d-ordre',
    icon: (size:number,ml?:number,mr?:number) => <BsBriefcase className={`h-${size} w-${size} ${ml ? 'ml-'+ml : ''} ${mr ? 'mr-'+mr : ''}`}/>,
    titleKey: 'routes.referentiel-donneurs-d-ordre.title',
    requireLogin: true,
    requireRoleFunction: ['manager','hr','sa'],
    requireOneOfEndpoints: ['GET /billing-customers'],
  },
  '/importer-donneurs-d-ordre': {
    route: 'importer-donneurs-d-ordre',
    icon: (size:number,ml?:number,mr?:number) => <CiImport className={`h-${size} w-${size} ${ml ? 'ml-'+ml : ''} ${mr ? 'mr-'+mr : ''}`}/>,
    titleKey: 'routes.importer-donneurs-d-ordre.title',
    requireLogin: true,
    requireRoleFunction: ['manager','hr','sa'],
    requireOneOfEndpoints: ['POST /billing-customers/import'],
  },
  '/utilisateurs': {
    route: 'utilisateurs',
    icon: (size:number,ml?:number,mr?:number) => <BsPeople className={`h-${size} w-${size} ${ml ? 'ml-'+ml : ''} ${mr ? 'mr-'+mr : ''}`}/>,
    titleKey: 'routes.users-liste.title',
    requireLogin: true,
    requireRoleFunction: ['administrator','sa'],
    requireOneOfEndpoints: ['GET /admin/users'],
  },
  '/creer-utilisateur': {
    route: 'creer-utilisateur',
    icon: (size:number,ml?:number,mr?:number) => <BsPlusCircle className={`h-${size} w-${size} ${ml ? 'ml-'+ml : ''} ${mr ? 'mr-'+mr : ''}`}/>,
    titleKey: 'routes.users-create.title',
    requireLogin: true,
    requireRoleFunction: ['administrator','sa'],
    requireOneOfEndpoints: ['POST /admin/users'],
  },
  '/utilisateurs/:id': {
    route: 'utilisateurs/:id',
    icon: (size:number,ml?:number,mr?:number) => <BsPencilSquare className={`h-${size} w-${size} ${ml ? 'ml-'+ml : ''} ${mr ? 'mr-'+mr : ''}`}/>,
    titleKey: 'routes.users-modify.title',
    requireLogin: true,
    requireRoleFunction: ['administrator','sa'],
    requireOneOfEndpoints: ['PUT /admin/users/{user_id}'],
  },
  '/collaborateurs': {
    route: 'collaborateurs',
    icon: (size:number,ml?:number,mr?:number) => <BsPeople className={`h-${size} w-${size} ${ml ? 'ml-'+ml : ''} ${mr ? 'mr-'+mr : ''}`}/>,
    titleKey: 'routes.collaborators-liste.title',
    requireLogin: true,
    requireRoleFunction: ['sa','manager'],
    requireOneOfEndpoints: ['GET /collaborators'],
  },
  '/creer-collaborateur': {
    route: 'creer-collaborateur',
    icon: (size:number,ml?:number,mr?:number) => <BsPersonPlus className={`h-${size} w-${size} ${ml ? 'ml-'+ml : ''} ${mr ? 'mr-'+mr : ''}`}/>,
    titleKey: 'routes.collaborators-create.title',
    requireLogin: true,
    requireRoleFunction: ['sa','manager'],
    requireOneOfEndpoints: ['POST /collaborators'],
  },
  '/collaborateurs/:id/modifier': {
    route: 'collaborateurs/:id/modifier',
    icon: (size:number,ml?:number,mr?:number) => <BsPencilSquare className={`h-${size} w-${size} ${ml ? 'ml-'+ml : ''} ${mr ? 'mr-'+mr : ''}`}/>,
    titleKey: 'routes.collaborators-modify.title',
    requireLogin: true,
    requireRoleFunction: ['sa','manager'],
    requireOneOfEndpoints: ['PUT /collaborators/{collaborator_id}'],
  },
  '/collaborateurs/:id/details': {
    route: 'collaborateurs/:id/details',
    icon: (size:number,ml?:number,mr?:number) => <BsLayoutTextSidebarReverse className={`h-${size} w-${size} ${ml ? 'ml-'+ml : ''} ${mr ? 'mr-'+mr : ''}`}/>,
    titleKey: 'routes.collaborators-details.title',
    requireLogin: true,
    requireRoleFunction: ['sa','manager'],
    requireOneOfEndpoints: ['GET /collaborators/{collaborator_id}'],
  },
  '/collaborateurs/importer': {
    route: 'collaborateurs/importer',
    icon: (size:number,ml?:number,mr?:number) => <CiImport className={`h-${size} w-${size} ${ml ? 'ml-'+ml : ''} ${mr ? 'mr-'+mr : ''}`}/>,
    titleKey: 'routes.collaborators-import.title',
    requireLogin: true,
    requireRoleFunction: ['sa','manager'],
    requireOneOfEndpoints: ['POST /collaborators/import'],
  },
  '/collaborateurs/stats-conges': {
    route: 'collaborateurs/stats-conges',
    icon: (size:number,ml?:number,mr?:number) => <BsPieChart className={`h-${size} w-${size} ${ml ? 'ml-'+ml : ''} ${mr ? 'mr-'+mr : ''}`}/>,
    titleKey: 'routes.collaborators-stats-conges.title',
    requireLogin: true,
    requireRoleFunction: ['sa','manager'],
    requireOneOfEndpoints: ['GET /ooo-days'],
  },
  '/organismes': {
    route: 'organismes',
    icon: (size:number,ml?:number,mr?:number) => <BsAirplane className={`h-${size} w-${size} ${ml ? 'ml-'+ml : ''} ${mr ? 'mr-'+mr : ''}`}/>,
    titleKey: 'routes.customers-liste.title',
    requireLogin: true,
    requireRoleFunction: ['sa','manager'],
    requireOneOfEndpoints: ['GET /audited-customers'],
  },
  '/creer-organisme': {
    route: 'creer-organisme',
    icon: (size:number,ml?:number,mr?:number) => <BsPlusCircle className={`h-${size} w-${size} ${ml ? 'ml-'+ml : ''} ${mr ? 'mr-'+mr : ''}`}/>,
    titleKey: 'routes.customer-create.title',
    requireLogin: true,
    requireRoleFunction: ['sa','manager'],
    requireOneOfEndpoints: ['POST /audited-customers'],
  },
  '/organismes/:id/modifier': {
    route: 'organismes/:id/modifier',
    icon: (size:number,ml?:number,mr?:number) => <BsPencilSquare className={`h-${size} w-${size} ${ml ? 'ml-'+ml : ''} ${mr ? 'mr-'+mr : ''}`}/>,
    titleKey: 'routes.customer-modify.title',
    requireLogin: true,
    requireRoleFunction: ['sa','manager'],
    requireOneOfEndpoints: ['PUT /audited-customers/{audited_customer_id}'],
  },
  '/organismes/:id/details': {
    route: 'organismes/:id/details',
    icon: (size:number,ml?:number,mr?:number) => <BsFileText className={`h-${size} w-${size} ${ml ? 'ml-'+ml : ''} ${mr ? 'mr-'+mr : ''}`}/>,
    titleKey: 'routes.customer-details.title',
    requireLogin: true,
    requireRoleFunction: ['sa','manager'],
    requireOneOfEndpoints: ['GET /audited-customers/{audited_customer_id}'],
  },
  '/organismes/importer': {
    route: 'organismes/importer',
    icon: (size:number,ml?:number,mr?:number) => <CiImport className={`h-${size} w-${size} ${ml ? 'ml-'+ml : ''} ${mr ? 'mr-'+mr : ''}`}/>,
    titleKey: 'routes.customers-import.title',
    requireLogin: true,
    requireRoleFunction: ['sa','manager'],
    requireOneOfEndpoints: ['POST /audited-customers/import'],
  },
  '/charges': {
    route: 'charges',
    icon: (size:number,ml?:number,mr?:number) => <BsTable className={`h-${size} w-${size} ${ml ? 'ml-'+ml : ''} ${mr ? 'mr-'+mr : ''}`}/>,
    titleKey: 'routes.charges-liste.title',
    requireLogin: true,
    requireRole: ['sa','manager'],
    requireOneOfEndpoints: ['GET /charges'],
  },
  '/creer-charge': {
    route: 'creer-charge',
    icon: (size:number,ml?:number,mr?:number) => <BsPlusCircle className={`h-${size} w-${size} ${ml ? 'ml-'+ml : ''} ${mr ? 'mr-'+mr : ''}`}/>,
    titleKey: 'routes.charge-create.title',
    requireLogin: true,
    requireRole: ['sa','manager'],
    requireOneOfEndpoints: ['POST /charges'],
  },
  '/creer-charge-depuis-model': {
    route: 'creer-charge-depuis-model',
    icon: (size:number,ml?:number,mr?:number) => <BsPlusCircle className={`h-${size} w-${size} ${ml ? 'ml-'+ml : ''} ${mr ? 'mr-'+mr : ''}`}/>,
    titleKey: 'routes.charge-create-from-model.title',
    requireLogin: true,
    requireRoleFunction: ['sa','manager'],
    requireOneOfEndpoints: ['POST /charges'],
  },
  '/importer-plan-de-charges': {
    route: 'importer-plan-de-charges',
    icon: (size:number,ml?:number,mr?:number) => <CiImport className={`h-${size} w-${size} ${ml ? 'ml-'+ml : ''} ${mr ? 'mr-'+mr : ''}`}/>,
    titleKey: 'routes.charges-import.title',
    requireLogin: true,
    requireRoleFunction: ['sa','manager'],
    requireOneOfEndpoints: ['POST /charges/import'],
  },
  '/charges-report': {
    route: 'charges-report',
    icon: (size:number,ml?:number,mr?:number) => <BsFileText className={`h-${size} w-${size} ${ml ? 'ml-'+ml : ''} ${mr ? 'mr-'+mr : ''}`}/>,
    titleKey: 'routes.charges-report.title',
    requireLogin: true,
    requireRoleFunction: ['sa','manager'],
    requireOneOfEndpoints: ['GET /charges/postpone'],
  },
  '/charges/:id/modifier': {
    route: 'charges/:id/modifier',
    icon: (size:number,ml?:number,mr?:number) => <BsPencilSquare className={`h-${size} w-${size} ${ml ? 'ml-'+ml : ''} ${mr ? 'mr-'+mr : ''}`}/>,
    titleKey: 'routes.charge-modify.title',
    requireLogin: true,
    requireRoleFunction: ['sa','manager'],
    requireOneOfEndpoints: ['PUT /charges/{charge_id}'],
  },
  '/charges/:id/details': {
    route: 'charges/:id/details',
    icon: (size:number,ml?:number,mr?:number) => <BsFileText className={`h-${size} w-${size} ${ml ? 'ml-'+ml : ''} ${mr ? 'mr-'+mr : ''}`}/>,
    titleKey: 'routes.charge-details.title',
    requireLogin: true,
    requireRoleFunction: ['sa','manager'],
    requireOneOfEndpoints: ['GET /charges/{charge_id}'],
  },
  '/model-charges': {
    route: 'model-charges',
    icon: (size:number,ml?:number,mr?:number) => <BsTable className={`h-${size} w-${size} ${ml ? 'ml-'+ml : ''} ${mr ? 'mr-'+mr : ''}`}/>,
    titleKey: 'routes.model-charges-liste.title',
    requireLogin: true,
    requireRoleFunction: ['administrator','sa','manager'],
    requireOneOfEndpoints: ['GET /charges'],
  },
  '/creer-model-charge': {
    route: 'creer-model-charge',
    icon: (size:number,ml?:number,mr?:number) => <BsPlusCircle className={`h-${size} w-${size} ${ml ? 'ml-'+ml : ''} ${mr ? 'mr-'+mr : ''}`}/>,
    titleKey: 'routes.chargemodel-create.title',
    requireLogin: true,
    requireRoleFunction: ['administrator','sa','manager'],
    requireOneOfEndpoints: ['POST /charges'],
  },
  '/model-charges/:id/modifier': {
    route: 'model-charges/:id/modifier',
    icon: (size:number,ml?:number,mr?:number) => <BsPencilSquare className={`h-${size} w-${size} ${ml ? 'ml-'+ml : ''} ${mr ? 'mr-'+mr : ''}`}/>,
    titleKey: 'routes.chargemodel-modify.title',
    requireLogin: true,
    requireRoleFunction: ['administrator','sa','manager'],
    requireOneOfEndpoints: ['PUT /charges/{charge_id}'],
  },
  '/model-charges/:id/details': {
    route: 'model-charges/:id/details',
    icon: (size:number,ml?:number,mr?:number) => <BsFileText className={`h-${size} w-${size} ${ml ? 'ml-'+ml : ''} ${mr ? 'mr-'+mr : ''}`}/>,
    titleKey: 'routes.chargemodel-details.title',
    requireLogin: true,
    requireRoleFunction: ['administrator','sa','manager'],
    requireOneOfEndpoints: ['GET /charges/{charge_id}'],
  },
  '/activites': {
    route: 'activites',
    icon: (size:number,ml?:number,mr?:number) => <FaChevronRight className={`h-${size} w-${size} ${ml ? 'ml-'+ml : ''} ${mr ? 'mr-'+mr : ''}`}/>,
    titleKey: 'routes.activities-liste.title',
    requireLogin: true,
    requireRoleFunction: [],
    requireOneOfEndpoints: ['GET /activities'],
  },
  '/activites/:id/modifier': {
    route: 'activites/:id/modifier',
    icon: (size:number,ml?:number,mr?:number) => <BsPencilSquare className={`h-${size} w-${size} ${ml ? 'ml-'+ml : ''} ${mr ? 'mr-'+mr : ''}`}/>,
    titleKey: 'routes.activities-modify.title',
    requireLogin: true,
    requireRoleFunction: [],
    requireOneOfEndpoints: ['PUT /activities/{activity_id}'],
  },
  '/activites/:id/details': {
    route: 'activites/:id/details',
    icon: (size:number,ml?:number,mr?:number) => <BsFileText className={`h-${size} w-${size} ${ml ? 'ml-'+ml : ''} ${mr ? 'mr-'+mr : ''}`}/>,
    titleKey: 'routes.activities-details.title',
    requireLogin: true,
    requireRoleFunction: [],
    requireOneOfEndpoints: ['GET /activities/{activity_id}'],
  },
  '/filters': {
    route: 'filters',
    icon: (size:number,ml?:number,mr?:number) => <BsFileText className={`h-${size} w-${size} ${ml ? 'ml-'+ml : ''} ${mr ? 'mr-'+mr : ''}`}/>,
    titleKey: 'routes.filters.title',
    requireLogin: true,
    requireRoleFunction: [],
    requireOneOfEndpoints: ['GET /users/{user_id}/filters'],
  },
  '/alertes': {
    route: 'alertes',
    icon: (size:number,ml?:number,mr?:number) => <BsBell className={`h-${size} w-${size} ${ml ? 'ml-'+ml : ''} ${mr ? 'mr-'+mr : ''}`}/>,
    titleKey: 'routes.alerts.title',
    requireLogin: true,
    requireRoleFunction: [],
    requireOneOfEndpoints: ['GET /alerts'],
    suffixKey: 'alertsBadge',
  },
  '/config-alertes': {
    route: 'config-alertes',
    icon: (size:number,ml?:number,mr?:number) => <BsBell className={`h-${size} w-${size} ${ml ? 'ml-'+ml : ''} ${mr ? 'mr-'+mr : ''}`}/>,
    titleKey: 'routes.config-alerts.title',
    requireLogin: true,
    requireRoleFunction: [],
    requireOneOfEndpoints: ['GET /alerts_preferences'],
  },
};
export default ROUTES;
